export default "__VITE_ASSET__DhD2jUNu__"